import '.gh{height:2rem;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.cv{justify-content:flex-end;}.ssr-plugin'
import '.bn{position:relative;}.ssr-plugin'
import '.h{flex-direction:column;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.av{cursor:pointer;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.dj{position:sticky;}.ssr-plugin'
import '.cf{top:0;}.ssr-plugin'
import '.gj{z-index:8;}.ssr-plugin'
import '.cn{background:var(--shades-white);}.ssr-plugin'
import '.br{padding:1rem;}.ssr-plugin'
import '.u{justify-content:space-between;}.ssr-plugin'
import { useCallback, useState } from 'react'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { MegaMenu } from '../../megaMenu/MegaMenu.mobile'
import { faBars } from '@fortawesome/pro-regular-svg-icons'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { pages } from '@app/util/links'
import { TextLink } from '@app/components/core/link/TextLink'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const ACCOUNT_SLOT_WIDTH = '6rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

export const TopNavBar = ({
  userName,
  avatar,
  isLoading,
}: TopNavBarProps) => {
  const [navigationMenuOpen, setNavigationMenuOpen] = useState(false)
  const { showAuthModal } = useAuthModal()
  const translations = useTranslations().app.common
  const renderAccountSection = useCallback(() => {
    if (isLoading) {
      return (
        <div className="gh"
          style={{
            width: ACCOUNT_SLOT_WIDTH,}}
        />
      )
    }

    return userName ? (
      <div className="g cv"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <ProfileMenu>
          <div className="bn g h b av"
          >
            <Avatar size="extra-small" labelSource={userName} image={avatar} />
          </div>
        </ProfileMenu>
      </div>
    ) : (
      <div className="g cv"
        style={{
          width: ACCOUNT_SLOT_WIDTH,
          animation: ACCOUNT_APPEAR_ANIMATION,
        }}
      >
        <Button
          variant="primary"
          label={translations.signUp}
          size="small"
          onClick={() => showAuthModal('signUp')}
        />
      </div>
    )
  }, [isLoading, userName, avatar, showAuthModal, translations.signUp])

  return (
    <div className="t dj cf gj cn"
    >
      <nav className="cn t g br u b"
      >
        <Button
          variant="link"
          icon={faBars}
          onClick={() => setNavigationMenuOpen(true)}
        />
        <TextLink to={pages.home} noHover={true} isBold={false} hasIcon={false}>
          <Image
            src={fullLogo}
            alt="Crowdbuilding Logo"
            resizeWidth={123}
            style={{
              width: 123,
            }}
          />
        </TextLink>
        {renderAccountSection()}
      </nav>
      <MegaMenu
        onClose={() => setNavigationMenuOpen(false)}
        isAuthenticated={userName !== undefined}
        isOpen={navigationMenuOpen}
      />
    </div>
  )
}
